import arjunPortrait from '../assets/arjun sharma .jpeg';
import { journeyTimeline, skillBars, techStack } from '../assets/siteData';
import { Section } from '../components/Section';

export function AboutPage() {
  return (
    <div className="about-page">
      <Section
        className="about-page__hero"
        eyebrow="About Arjun"
        title="Developer precision, founder ambition, and educator clarity in one premium identity"
        description="A journey built across freelancing, startup thinking, product execution, and future-tech education."
      >
        <div className="timeline timeline--neon">
          {journeyTimeline.map((item) => (
            <article className="timeline__item glass-panel" key={item.year}>
              <span className="timeline__year">{item.year}</span>
              <h3>{item.title}</h3>
              <p>{item.description}</p>
            </article>
          ))}
        </div>
      </Section>

      <Section className="section--split about-page__split">
        <div className="glass-panel split-card">
          <p className="eyebrow">Core Skills</p>
          <div className="skill-list">
            {skillBars.map((skill) => (
              <div className="skill-item" key={skill.label} style={{ '--progress': `${skill.value}%` }}>
                <div className="skill-item__head">
                  <span>{skill.label}</span>
                  <strong>{skill.value}%</strong>
                </div>
                <div className="skill-track">
                  <span className="skill-fill" />
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="glass-panel split-card about-vision">
          <div className="about-vision__portrait">
            <img src={arjunPortrait} alt="Arjun Sharma standing portrait" />
          </div>
          <p className="eyebrow">Vision</p>
          <h2>Build digital products and learning experiences that feel instantly credible.</h2>
          <p>
            The goal is simple: ship work with premium visuals, clear thinking, and practical value so clients, students, and collaborators feel confident immediately.
          </p>
        </div>
      </Section>

      <Section eyebrow="Tech Stack" title="Tools, platforms, and systems across web and robotics">
        <div className="tech-grid">
          {techStack.map((item) => (
            <article className="tech-card tech-card--image glass-panel" key={item.title}>
              <div className="tech-card__media">
                <img className="tech-card__image" src={item.image} alt={item.alt} loading="lazy" />
              </div>
              <div className="tech-card__body">
                <span className="tech-card__category">{item.category}</span>
                <h3>{item.title}</h3>
              </div>
            </article>
          ))}
        </div>
      </Section>
    </div>
  );
}
